import React from 'react';
import { Info } from 'lucide-react';
import { useHelp } from '@/contexts/HelpContext';

/**
 * Small info button to place next to any page title.
 * Opens the contextual help panel for the current page.
 *
 * Usage:
 *   <h1 className="text-3xl font-bold">My Page <PageInfoButton /></h1>
 */
const PageInfoButton: React.FC = () => {
  const { openHelp } = useHelp();
  return (
    <button
      onClick={openHelp}
      className="inline-flex items-center justify-center w-6 h-6 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-colors ml-2 align-middle"
      title="Page info & guidance"
    >
      <Info size={16} />
    </button>
  );
};

export default PageInfoButton;
